import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class CsUnitModel extends BaseModel {

    constructor() {
        super({
                name: "cs_unit",
                tableName: 'cs_unit',
                label: "Quản Lý Unit",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                // unit_id: {
                //     name: "unit_id",
                //     display: false
                // },
                code: { 
                    name: 'code',
                    type: "String",
                    class: "center",
                    label: 'Mã unit',
                    filter: {type: 'input', match: 'contains'},
                },
                name: { 
                    name: 'name',
                    type: "String",
                    class: "center",
                    label: 'Tên unit',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                company_name: {
                    name: 'company_name',
                    type: "String",
                    class: "center",
                    label: 'Tên công ty',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.company_name = "";
                    }
                },
                company: {
                    refs: 'company {id name }',
                    display: false
                },
                unit_has_kind_type: {
                    refs: 'unit_has_kind_type {kindtype {id name}}',
                    display: false
                },
                farm_name: { 
                    name: 'farm_name',
                    type: "String",
                    class: "center",
                    label: 'Tên trang trại',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.farm_name = "";
                    }
                },
                farm: {
                    refs: 'farm {id name }',
                    display: false
                },
                user: {
                    refs: 'user {id fullname}',
                    display: false
                },
                dimensions: {
                    name: "dimensions",
                    display: false
                },
                // row: {
                //     name: "row",
                //     label: "Số lượng hàng",
                //     type: "Number",
                //     class: "center",
                // },
                // column: {
                //     name: "column",
                //     label: "Số lượng cột",
                //     type: "Number",
                //     class: "center",
                // },
                box: {
                    name: "box",
                    label: "Số lượng hộp",
                    type: "Number",
                    class: "center",
                },
                volume: {
                    name: "volume",
                    label: "Thể tích unit",
                    type: "Number",
                    class: "center",
                },
                box_active: {
                    name: "box_active",
                    label: "SL hộp có cua",
                    type: "Number",
                    class: "center",
                    computed: (data) => {
                        data.box_active = 0;
                    }
                },
                assign: { 
                    name: 'assign',
                    type: "String",
                    class: "center",
                    label: 'Người phân công',
                    width: 10,
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.assign = "";
                    }
                },
                equipment_has_units: {
                    refs: 'equipment_has_units {equipment {id name}}',
                    display: false
                },
                block: {
                    refs: 'block {id box obj_boxes {id total active kind {id code}}}',
                    display: false
                },
                users:{
                    refs: 'users {user {id fullname}}',
                    display: false
                },
                equipment:{ 
                    name: 'equipment',
                    type: "CustomUrl",
                    label: 'Thiết bị',
                    class: 'center',
                    computed: (data) => {
                        data.equipment = 0;
                    }
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    class: "center",
                    label: 'Ngày cập nhật',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },

                active: {
                    name: "active",
                    type: "Selection", 
                    custom: 'SelectionText',
                    label: "Trạng thái",
                    width: 6,
                    class: "center",
                    options: [
                        {value : true , label: "Hoạt động"},
                        {value : false , label : "Không hoạt động"}
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },

                row: {
                    name: "row",
                    display: false
                },

                column: {
                    name: "column",
                    display: false
                },

            },
            )
    }

}